// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonObjects = {
  baseImage: "KVM 基礎イメージ",
  containerImage: "コンテナイメージ",
  customImage: "カスタムイメージ",
  applicationImage: "Application Image",
  dynamipsIosImage: "Dynamips IOS イメージ",
  physicalDevice: "物理デバイス",
  spec: "仕様",
  topologyTemplate: "トポロジテンプレート",
  topologyVersion: "トポロジバージョン",
  executionSnapshot: "実行スナップショット",
  topologyViewSnapshot: "ビュースナップショット",
  containerSpec: "コンテナ仕様",
  vmSpec: "VM 仕様",
  simulatorModel: "シミュレーションモデル",
  loginCredential: "ログイン認証情報",
  accessPort: "アクセスポート",
  imagePortServiceProtocol: "ポートサービスプロトコル",
  applicationParameter: "アプリケーションパラメータ",
  applicationAction: "アプリケーションアクション",
  actionInputParameter: "アクション入力パラメータ",
  outputItem: "出力項目",
} as const;
